 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"39eafb4","1":"fffc46d","2":"8644ff5","3":"88e7e75","4":"6e46184","5":"959af18","6":"630b181","7":"3c1b081","8":"ab9b407","9":"5e2afc8","10":"92cd069","11":"8b8868b","12":"644773a","13":"e5f0f06","14":"2b66d9e","15":"d0a5459","16":"51581ed","17":"1b626b6","18":"ec7624c","19":"9adf04c","20":"1561e6e","21":"c55c832","22":"18d017e","23":"0d3a859","24":"e204506","25":"9cec3a8","26":"a088c2e","27":"2fe94b7","28":"412986a","29":"91d925a","30":"dba0b05","31":"14c139a","32":"35d03c2","33":"db276ba","34":"cdbb1c3","35":"b115b0e","36":"a01687e","37":"6c20d68","38":"7d4c6b2","39":"d817ff2","40":"276f1dc","41":"e812be4","42":"375df90","43":"e5ba3c8","44":"9c129d1","45":"2105242","46":"2d38a44","47":"fd8d795","48":"b65bc83","49":"29e7bc7","50":"9d79262","51":"fbc3ded","52":"c90897b","53":"c9ff93e","54":"fbf8ef9","55":"419c118","56":"2e12ab3","57":"f7fc048","58":"4246bae","59":"4f15668","60":"94fccc3","61":"20abc8f","62":"c1a2fdf","63":"9ab9a0e","64":"2d25289","65":"9654fdb","66":"19e8cd5","67":"8e29c74","68":"0ac9c76","69":"acb2cbb","70":"4e3200c","71":"1700d45","72":"a177136","73":"c2ff528","74":"178fa5d","75":"28e6e22","76":"9edd51b","77":"2af7392","78":"6b05f35","79":"e3b3538","80":"d13de36","81":"452a08d","82":"85881b6","83":"bb9becc","84":"5f44882","85":"07c2173","86":"274646c","87":"e67211e","88":"0f2d759","89":"1d0f718","90":"eaa1217","91":"b1cfb7c","92":"45f9cb6","93":"3a0ad0f","94":"742b913","95":"ae5e37f","96":"7ef413a","97":"c1fcf9e","98":"576ed53","99":"6915c0d","100":"bf223cd","101":"2cbd029","102":"8909e68","103":"0725603","104":"a8fcc37","105":"9cd63ae","106":"2bc1ff0","107":"00f4fdb","108":"62d1145","109":"d9b8821","110":"a2deea2","111":"dc3cf6d","112":"18a7d99","113":"cd321d0","114":"7b6dc5d","115":"a12bce3","116":"a2e8448","117":"3bf4168","components/hot-iframe-sso":"21f6eca","vendors/pages/index":"96981f9","components/hot-app-store-button":"8820aeb","pages/index":"257c8ef","components/delay-hydration":"dab6343","components/hot-accordion":"ec8978d","components/hot-accordion-item":"d4081fd","components/hot-organic-accordion":"157a713","components/hot-organic-accordion-item":"5983737","components/hot-organic-accordion-item-custom":"9c2d2d5","components/hot-organic-button":"942295c","components/hot-tag":"7fa5249","components/hot-video":"3eaeaa0","components/hydration-status":"df7f154","lang-es-co.js":"67dbc76","lang-es-es.js":"1105ebe","lang-es-mx.js":"59912df","lang-es.js":"41c5bc1","lang-fr.js":"4311ddc","lang-it.js":"ec618a7","lang-jp.js":"ca1c7aa","lang-pt-br.js":"0948a9c","pages/404":"1287fa7","pages/about":"ffe73a7","pages/affiliates":"f4afccd","pages/club":"edc472b","pages/hotmart-app":"74e2e7e","pages/is-hotmart-for-me":"03294dd","pages/lp-producer":"4183ea1","pages/members-area/index/pages/members-area/paid-media":"5121390","pages/members-area/index":"4164b30","pages/members-area/paid-media":"6ce29e6","pages/members-area/thank-you":"34935f8","pages/payments":"575c832","pages/pricing":"dcc3c30","pages/producers":"ca22c97","pages/sitemap":"63421cc","pages/solutions":"f595470","pages/tour/_id":"e39e4f5","pages/tour/index":"8a91f85"}[chunkId] + ".modern.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var linkExists = false
 		var cssChunks = {"0":1,"2":1,"3":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"64":1,"65":1,"66":1,"67":1,"68":1,"69":1,"70":1,"71":1,"72":1,"73":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"90":1,"91":1,"92":1,"93":1,"94":1,"95":1,"96":1,"97":1,"98":1,"99":1,"100":1,"101":1,"102":1,"103":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"110":1,"111":1,"112":1,"113":1,"114":1,"115":1,"116":1,"components/hot-iframe-sso":1,"components/hot-app-store-button":1,"pages/index":1,"components/hot-accordion":1,"components/hot-accordion-item":1,"components/hot-organic-accordion":1,"components/hot-organic-accordion-item":1,"components/hot-organic-accordion-item-custom":1,"components/hot-organic-button":1,"components/hot-tag":1,"components/hot-video":1,"pages/affiliates":1,"pages/club":1,"pages/hotmart-app":1,"pages/lp-producer":1,"pages/members-area/index/pages/members-area/paid-media":1,"pages/members-area/index":1,"pages/members-area/thank-you":1,"pages/pricing":1,"pages/solutions":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"bc92dc3","1":"31d6cfe","2":"e62ce8b","3":"cbabb86","4":"31d6cfe","5":"cdcdb3d","6":"66645f7","7":"08c6c3b","8":"4007b79","9":"54a8347","10":"351380d","11":"19989c6","12":"c8112fa","13":"68c3433","14":"75e67e8","15":"39c5a44","16":"31d6cfe","17":"31d6cfe","18":"96c24c7","19":"9c4837c","20":"be814ea","21":"c32563d","22":"241ffb1","23":"e863632","24":"4188e7c","25":"5600e18","26":"0f3ddc3","27":"d70f182","28":"024b8d9","29":"c042bc4","30":"fdade79","31":"a04a862","32":"d75264e","33":"93aff2e","34":"ad26373","35":"80e4f98","36":"a020706","37":"eb8103c","38":"4468057","39":"08fe6d2","40":"064c4b1","41":"09c7f16","42":"ac4ef9f","43":"f75b75e","44":"689759f","45":"e48ac1d","46":"f3e0ea2","47":"99d4bdc","48":"00f530c","49":"de69fb0","50":"ab0e1fc","51":"26aad64","52":"56e0dd1","53":"727ff82","54":"fef25de","55":"5c5ce5e","56":"6e1d829","57":"f435948","58":"dd2d0c8","59":"4a8c44c","60":"34f525f","61":"30aa5b5","62":"72bfb9d","63":"b5d48e2","64":"f759bb7","65":"56abd46","66":"5535ef7","67":"df1bd4f","68":"c1e4f65","69":"3f9d89d","70":"3f53998","71":"047da8f","72":"c042bc4","73":"61d5c1c","74":"8e580b9","75":"ab64f81","76":"66645f7","77":"77a873c","78":"e4f3dcf","79":"f52ea8e","80":"b54ff1c","81":"5670dd5","82":"a5c4bdf","83":"848597c","84":"a2a2e07","85":"5a61a94","86":"8945d3a","87":"96b37b0","88":"972a3e4","89":"01bb85e","90":"9b60878","91":"85f5fcb","92":"b82956b","93":"77dcec5","94":"9e3df9d","95":"885540e","96":"45deec5","97":"76d7586","98":"ae59dbb","99":"bedc643","100":"fe5f52e","101":"df95389","102":"0a0f1f7","103":"80e10ea","104":"0681781","105":"f0d8317","106":"443998a","107":"573a98f","108":"d8beaf2","109":"6223a7e","110":"9a60522","111":"c881277","112":"1d007c1","113":"f68e80c","114":"da26f13","115":"e22d49c","116":"11a0668","117":"31d6cfe","components/hot-iframe-sso":"d66ab2d","vendors/pages/index":"31d6cfe","components/hot-app-store-button":"935e4c5","pages/index":"1455007","components/delay-hydration":"31d6cfe","components/hot-accordion":"ab64f81","components/hot-accordion-item":"5a2d087","components/hot-organic-accordion":"bd7f697","components/hot-organic-accordion-item":"1c5ba8d","components/hot-organic-accordion-item-custom":"c0c5be2","components/hot-organic-button":"c730dbd","components/hot-tag":"d70ca71","components/hot-video":"00c5276","components/hydration-status":"31d6cfe","lang-es-co.js":"31d6cfe","lang-es-es.js":"31d6cfe","lang-es-mx.js":"31d6cfe","lang-es.js":"31d6cfe","lang-fr.js":"31d6cfe","lang-it.js":"31d6cfe","lang-jp.js":"31d6cfe","lang-pt-br.js":"31d6cfe","pages/404":"31d6cfe","pages/about":"31d6cfe","pages/affiliates":"97f7dff","pages/club":"de22bd5","pages/hotmart-app":"8cca359","pages/is-hotmart-for-me":"31d6cfe","pages/lp-producer":"5691784","pages/members-area/index/pages/members-area/paid-media":"a222544","pages/members-area/index":"de22bd5","pages/members-area/paid-media":"31d6cfe","pages/members-area/thank-you":"e945570","pages/payments":"31d6cfe","pages/pricing":"be079d9","pages/producers":"31d6cfe","pages/sitemap":"31d6cfe","pages/solutions":"236939f","pages/tour/_id":"31d6cfe","pages/tour/index":"31d6cfe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) {
 						linkExists = true
 						return resolve();
 					}
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(!linkExists && supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"bc92dc3","1":"31d6cfe","2":"e62ce8b","3":"cbabb86","4":"31d6cfe","5":"cdcdb3d","6":"66645f7","7":"08c6c3b","8":"4007b79","9":"54a8347","10":"351380d","11":"19989c6","12":"c8112fa","13":"68c3433","14":"75e67e8","15":"39c5a44","16":"31d6cfe","17":"31d6cfe","18":"96c24c7","19":"9c4837c","20":"be814ea","21":"c32563d","22":"241ffb1","23":"e863632","24":"4188e7c","25":"5600e18","26":"0f3ddc3","27":"d70f182","28":"024b8d9","29":"c042bc4","30":"fdade79","31":"a04a862","32":"d75264e","33":"93aff2e","34":"ad26373","35":"80e4f98","36":"a020706","37":"eb8103c","38":"4468057","39":"08fe6d2","40":"064c4b1","41":"09c7f16","42":"ac4ef9f","43":"f75b75e","44":"689759f","45":"e48ac1d","46":"f3e0ea2","47":"99d4bdc","48":"00f530c","49":"de69fb0","50":"ab0e1fc","51":"26aad64","52":"56e0dd1","53":"727ff82","54":"fef25de","55":"5c5ce5e","56":"6e1d829","57":"f435948","58":"dd2d0c8","59":"4a8c44c","60":"34f525f","61":"30aa5b5","62":"72bfb9d","63":"b5d48e2","64":"f759bb7","65":"56abd46","66":"5535ef7","67":"df1bd4f","68":"c1e4f65","69":"3f9d89d","70":"3f53998","71":"047da8f","72":"c042bc4","73":"61d5c1c","74":"8e580b9","75":"ab64f81","76":"66645f7","77":"77a873c","78":"e4f3dcf","79":"f52ea8e","80":"b54ff1c","81":"5670dd5","82":"a5c4bdf","83":"848597c","84":"a2a2e07","85":"5a61a94","86":"8945d3a","87":"96b37b0","88":"972a3e4","89":"01bb85e","90":"9b60878","91":"85f5fcb","92":"b82956b","93":"77dcec5","94":"9e3df9d","95":"885540e","96":"45deec5","97":"76d7586","98":"ae59dbb","99":"bedc643","100":"fe5f52e","101":"df95389","102":"0a0f1f7","103":"80e10ea","104":"0681781","105":"f0d8317","106":"443998a","107":"573a98f","108":"d8beaf2","109":"6223a7e","110":"9a60522","111":"c881277","112":"1d007c1","113":"f68e80c","114":"da26f13","115":"e22d49c","116":"11a0668","117":"31d6cfe","components/hot-iframe-sso":"d66ab2d","vendors/pages/index":"31d6cfe","components/hot-app-store-button":"935e4c5","pages/index":"1455007","components/delay-hydration":"31d6cfe","components/hot-accordion":"ab64f81","components/hot-accordion-item":"5a2d087","components/hot-organic-accordion":"bd7f697","components/hot-organic-accordion-item":"1c5ba8d","components/hot-organic-accordion-item-custom":"c0c5be2","components/hot-organic-button":"c730dbd","components/hot-tag":"d70ca71","components/hot-video":"00c5276","components/hydration-status":"31d6cfe","lang-es-co.js":"31d6cfe","lang-es-es.js":"31d6cfe","lang-es-mx.js":"31d6cfe","lang-es.js":"31d6cfe","lang-fr.js":"31d6cfe","lang-it.js":"31d6cfe","lang-jp.js":"31d6cfe","lang-pt-br.js":"31d6cfe","pages/404":"31d6cfe","pages/about":"31d6cfe","pages/affiliates":"97f7dff","pages/club":"de22bd5","pages/hotmart-app":"8cca359","pages/is-hotmart-for-me":"31d6cfe","pages/lp-producer":"5691784","pages/members-area/index/pages/members-area/paid-media":"a222544","pages/members-area/index":"de22bd5","pages/members-area/paid-media":"31d6cfe","pages/members-area/thank-you":"e945570","pages/payments":"31d6cfe","pages/pricing":"be079d9","pages/producers":"31d6cfe","pages/sitemap":"31d6cfe","pages/solutions":"236939f","pages/tour/_id":"31d6cfe","pages/tour/index":"31d6cfe"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/app-hotmart/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
